// extracted by mini-css-extract-plugin
export default {"infoBlock":"UserOrders_infoBlock__o7nQ3","deliveryinfo":"UserOrders_deliveryinfo__BmW0I","recipientInfo":"UserOrders_recipientInfo__uLtU6"};